"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableStateEventEditor = exports.StateEventEditor = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const StateTransitionPicker_1 = __importDefault(require("../pickers/StateTransitionPicker"));
const StateEventConditions_1 = __importDefault(require("./StateEventConditions"));
const StyledAccordion = (0, styled_components_1.default)(core_1.Accordion) `
  &.dragging {
    opacity: 0.75;
  }
  .MuiAccordionSummary-root {
    padding-left: 5px;
    &.Mui-expanded {
      min-height: unset;
    }
    .MuiAccordionSummary-content {
      margin: 12px 0px;
      align-items: center;
      .delete-button {
        margin-right: 7px;
      }
    }
  }
  .drag-handle {
    display: flex;
  }
`;
const StateEventEditor = props => {
    const { shape, event, workflow, taskTypeId, expanded = false, isDragging = false, accordionProps, dragHandleProps, setExpanded, updateShape, updateWorkflow } = props;
    const eventShapeRef = (0, react_1.useRef)();
    const [isOpenDeleteDialog, setIsOpenDeleteDialg] = (0, react_1.useState)(false);
    const classes = [];
    (accordionProps === null || accordionProps === void 0 ? void 0 : accordionProps.className) && classes.push(accordionProps.className);
    isDragging && classes.push('dragging');
    const getEventShape = () => {
        var _a;
        if (!eventShapeRef.current) {
            // get event type shape with same event data
            eventShapeRef.current = (_a = shape.parent) === null || _a === void 0 ? void 0 : _a.shapes.find(shape => shape.data === event);
        }
        return eventShapeRef.current;
    };
    const setEventShapeName = (value) => {
        const eventShape = getEventShape();
        if (eventShape) {
            eventShape.name = event.description || (value && value + '?');
        }
    };
    if (!event.transitions || event.transitions.length === 0) {
        // make sure there is always at least one target in the transition defined
        // otherwise field won't show up
        event.transitions = [{ target: event.stateNode.path }];
    }
    return (react_1.default.createElement(StyledAccordion, Object.assign({}, accordionProps, { expanded: expanded, className: classes.join(' '), onChange: (_, expanded) => setExpanded === null || setExpanded === void 0 ? void 0 : setExpanded(expanded) }),
        react_1.default.createElement(core_1.AccordionSummary, { expandIcon: react_1.default.createElement(icons_1.ExpandMore, null), className: 'transition-panel' },
            react_1.default.createElement("div", Object.assign({ className: 'drag-handle' }, dragHandleProps),
                react_1.default.createElement(icons_1.DragIndicator, { color: 'disabled' })),
            react_1.default.createElement(core_1.IconButton, { size: 'small', className: 'delete-button', onClick: event => {
                    event.stopPropagation();
                    setIsOpenDeleteDialg(true);
                } },
                react_1.default.createElement(icons_1.RemoveCircleOutline, null)),
            event.name || 'New Transition'),
        react_1.default.createElement(core_1.AccordionDetails, null,
            react_1.default.createElement("div", { className: 'form-fields' },
                react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Event Name', className: 'field', value: event.name || '', onBlur: () => updateWorkflow(), onChange: ev => {
                        const { value = '' } = ev.target;
                        event.name = value;
                        setEventShapeName(value);
                        updateShape();
                    } }),
                react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', variant: 'outlined', className: 'field', label: 'Event Description', value: event.description || '', onChange: e => {
                        const { value = '' } = e.target;
                        event.description = value;
                        setEventShapeName(event.name || value);
                        updateShape();
                    }, onBlur: () => updateWorkflow(false) }),
                react_1.default.createElement(core_1.FormControlLabel, { className: 'field', label: 'Is Transient?', control: react_1.default.createElement(core_1.Switch, { color: 'primary', checked: event.isTransient || false, onChange: (_, checked) => {
                            event.isTransient = checked;
                            updateShape();
                            updateWorkflow();
                        } }) }),
                event.transitions.map((transition, index) => (react_1.default.createElement(react_1.Fragment, { key: index },
                    react_1.default.createElement(StateTransitionPicker_1.default, { shape: shape, workflow: workflow, transition: transition, onChange: stateNode => {
                            if (stateNode === null || stateNode === void 0 ? void 0 : stateNode.path) {
                                transition.target = stateNode.path;
                                event.updateTransitions(event.transitions);
                                updateWorkflow(false);
                            }
                        } }),
                    react_1.default.createElement(StateEventConditions_1.default, { event: event, transition: transition, taskTypeId: taskTypeId, onChange: transition => {
                            event.transitions[index] = transition;
                            updateWorkflow(false);
                        } })))))),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: isOpenDeleteDialog, title: `Delete ${event.name} transition`, message: 'Are you sure you want to delete this transition?', onCancel: () => setIsOpenDeleteDialg(false), onConfirm: () => {
                setIsOpenDeleteDialg(false);
                event.remove();
                updateWorkflow();
            } })));
};
exports.StateEventEditor = StateEventEditor;
exports.default = exports.StateEventEditor;
const SortableStateEventEditor = props => {
    const { event } = props;
    const { attributes, isDragging, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id: event.id });
    return (react_1.default.createElement(exports.StateEventEditor, Object.assign({}, props, { isDragging: isDragging, dragHandleProps: Object.assign(Object.assign({}, attributes), listeners), accordionProps: {
            innerRef: setNodeRef,
            style: {
                opacity: isDragging ? 0.75 : undefined,
                transform: utilities_1.CSS.Translate.toString(transform),
                transition: transition || undefined
            }
        } })));
};
exports.SortableStateEventEditor = SortableStateEventEditor;
//# sourceMappingURL=StateEventEditor.js.map